export const FEATURE_FLAG_RECORD_MAP = {
  // SHARED
  AdminFeeReturnToCheckout: 'ADMIN_FEE_RETURN_TO_CHECKOUT',
  AdminFeeLoyalty: 'ADMIN_FEE_LOYALTY',
  CheckoutReservationsDecoupling: 'CHECKOUT_RESERVATIONS_DECOUPLING',
  CheckoutReservationsDecouplingPhaseTwo:
    'CHECKOUT_RESERVATIONS_DECOUPLING_PHASE_TWO',
  ServicingAndWarrantyFlag: 'SERVICING_AND_WARRANTY_FLAG',
  DisableCinchCare: 'DISABLE_CINCHCARE',
  GapInsuranceFlag: 'GAP_INSURANCE_FLAG',
  EnabledZendeskScript: 'ENABLE_ZENDESK_SCRIPT',
  VehicleCardV2: 'VEHICLE_CARD_V2',
  EnableEmailQuote: 'ENABLE_EMAIL_QUOTE',
  EnableQuotesMarketing: 'ENABLE_QUOTES_MARKETING',
  ShowQuoteTermMonths: 'SHOW_QUOTE_TERM_MONTHS',
  ShowScorelessTrustpilot: 'SHOW_SCORELESS_TRUSTPILOT',
  SoftSearchChanges: 'SOFT_SEARCH_CHANGES',
  PDPSoftSearch: 'PDP_SOFT_SEARCH',
  showCinchCoverInProfile: 'SHOW_CINCH_COVER_IN_PROFILE',
  showMultiTermVAPsInProfile: 'SHOW_MULTI_TERM_VAPS_IN_PROFILE',
  showTyreInsurance: 'SHOW_TYRE_INSURANCE_IN_PROFILE',
  showGAPInsuranceInProfile: 'SHOW_GAP_INSURANCE_IN_PROFILE',
  showSelfServiceRenewalsV3: 'SHOW_SELF_SERVICE_RENEWALS_V3',
  UseRefreshToken: 'USE_REFRESH_TOKEN',
  ShowHelpAndSupportChanges: 'SHOW_HELP_AND_SUPPORT_CHANGES',
  EnableSegmentTrackingInUsedCars: 'ENABLE_SEGMENT_TRACKING_IN_USED_CARS',
  EnableSellMyCar: 'ENABLE_SELL_MY_CAR',
  EnableNewProfileHeader: 'ENABLE_NEW_PROFILE_HEADER',
  FinanceApplicationCheckOutBanner: 'FINANCE_APPLICATION_CHECKOUT_BANNER',
  CarFinanceShowTrustPilot: 'CAR_FINANCE_SHOW_TRUST_PILOT',
  EnableNewCarsFinance: 'ENABLE_NEW_CARS_FINANCE',
  EnableVAPSFeatureCarMaintenance: 'ENABLE_VAPS_FEATURE_CAR_MAINTENANCE',
  FinOfferCommission: 'FIN_OFFER_COMMISSION',
  FinanceSoftSearchV2: 'FINANCE_SOFT_SEARCH_V2',
  FinanceApplicationAddressHistorySubBuilding:
    'FINANCE_APPLICATION_ADDRESS_HISTORY_SUBBUILDING',
  EnableServiceBooking: 'ENABLE_SERVICE_BOOKING',
  PartExEquityRelease: 'PART_EX_EQUITY_RELEASE',
  HomeHeroFormWithNewCarsTab: 'HOME_HERO_FORM_WITH_NEW_CARS_TAB',

  // ACQUISITION AND CONTENT
  EnableFavouritingHomePageChanges: 'HOMEPAGE_FAVOURITING',

  // SEARCH
  SearchDataDrivenSortOrder: 'SEARCH_DATA_DRIVEN_SORT_ORDER',
  NewCarsFiltersFlag: 'NEW_CARS_FILTERS_FLAG',
} as const

export type FeatureFlags = typeof FEATURE_FLAG_RECORD_MAP

export type IFeatureFlags = Record<
  FeatureFlags[keyof FeatureFlags],
  'true' | 'false'
>
